<div class="function-details-renderer-wrapper">
  <div class="function-details-box" *ngIf="params.pinned === null">
    <div class="p-3 flex flex-wrap">
      <div class="w-full p-3 function-details-title">
        {{ functionDefinition?.function_name }}
        <div class="tag-box">
          <fa-icon
            *ngIf="functionDefinition?.tag_fontawesome_logo"
            [icon]="['fal', $any(functionDefinition?.tag_fontawesome_logo)]"
            class="fs-07 mr-1"
          ></fa-icon>
          {{ functionDefinition?.tag }}
        </div>
      </div>
      <div class="w-1/2 p-3">
        <div>
          <div class="text-gray-1100 font-medium mb-1">Description</div>
          <p>{{ functionDefinition?.description }}</p>
        </div>
        <div class="mt-2" *ngIf="functionDefinition?.example">
          <div class="text-gray-1100 font-medium mb-1">Example</div>
          <markdown [data]="functionDefinition?.example!"></markdown>
        </div>
        <div></div>
      </div>
      <div class="w-1/2 p-3">
        <table class="input-output-table">
          <tr>
            <td colspan="5" class="instruction-td">Result</td>
          </tr>
          <tr>
            <td>Output</td>
            <td>
              <div class="ml-2">
                <y42-column-type-icon
                  *ngIf="functionDefinition?.output"
                  [type]="functionDefinition?.output!"
                ></y42-column-type-icon>
              </div>
            </td>
            <td colspan="2"></td>
          </tr>
          <tr [hidden]="functionDefinition?.parameters?.length || 0 < 1">
            <td colspan="5" class="instruction-td">
              Parameter{{
                (functionDefinition?.parameters?.length || 0) > 1
                  ? 's ' + (functionDefinition?.parameters?.length || 0) + 'x'
                  : ''
              }}
            </td>
          </tr>
          <tr
            *ngFor="
              let input of functionDefinition?.parameters || [];
              trackBy: trackByFuncDefParamsIndex;
              let i = index
            "
            [hidden]="(functionDefinition?.parameters?.length || 0) < 1"
            class="border-bottom"
          >
            <td>
              {{ input.name }}
            </td>
            <td>
              <div class="ml-2 w-full">
                <div class="w-full aligner-start">
                  <y42-column-type-icon
                    *ngFor="let type of input.splittedByVerticalLineTsTypes; trackBy: trackByStringIndex"
                    [type]="type | tsTypeToColumnType"
                    class="mr-2"
                  ></y42-column-type-icon>
                </div>
              </div>
            </td>
            <td>
              <div class="ml-2">
                {{ input.required ? 'required' : 'not required' }}
              </div>
            </td>
            <td *ngIf="input.typescript_type !== typescriptTypeEnum.ENUM">
              <div class="ml-2">
                {{ input.description }}
              </div>
            </td>
            <td *ngIf="input.typescript_type === typescriptTypeEnum.ENUM">
              <div class="ml-2">Allowed Values: {{ input.enum_values }}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
